/* eslint-disable indent */
import { html, css, LitElement } from 'lit';
import { customElement, state, query } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import sharedStyles from '../../app/styles.js';
import { loadCompositionsIfNeeded } from '../../store/comp/comp.js';
import { navigate } from '../../store/route/route.js';
import { previewComposition } from '../../store/preview/player.js';
import { translate } from '../../helpers/translate.js';
import '@lit-labs/virtualizer';
import '@polymer/app-layout/app-layout.js';
import '@vaadin/context-menu/theme/material/vaadin-context-menu.js';
import '@sdb-develop/learning-frontend';
import '../shared/sdb-search-input.js';
import '../shared/sdb-loading.js';
import '../shared/sdb-status-message.js';
import moment from 'moment/dist/moment.js';

@customElement('sdb-composition-list')
class SdbCompositionList extends connect(store)(LitElement) {

    @state()
    accessor compositions;

    @state()
    accessor total;

    @state()
    accessor search;

    @state()
    accessor isLoadingFirstTime;

    @state()
    accessor user;

    @state()
    accessor selectedId;

    @query('#distribution_dialog')
    accessor distributionDialog;

    stateChanged(state) {
        this.compositions = state.comp.list;
        this.total = state.comp.total;
        this.search = state.comp.search;
        this.isLoadingFirstTime = state.comp.status === 'loading' && state.comp.page === -1;
        this.user = state.auth.user;
    }

    static styles = [
        sharedStyles,
        css`
            :host {
                max-width: var(--tcg-content-max-width);
                width: 100%;
            }

            #compositions_list {
                contain: none !important; /* lit-virtualizer hack */
            }

            sdb-content-listitem {
                width: 100%; /* lit-virtualizer screws this up */
            }



            tcg-composition-publishinfo {
                margin-left: 66px;
            }

            .nowrap {
                white-space: nowrap;
            }
        `,
    ];

    render() {
        if (this.isLoadingFirstTime) {
            return html`<sdb-loading></sdb-loading>`;
        }

        return html`
            <sdb-layout-60-40>
                <sdb-nav-titlebar slot="left">
                    <span>${translate('headerCompositions')}</span>
                    <span ?hidden=${this.total === undefined}>&nbsp;(${this.total})</span>
                </sdb-nav-titlebar>
                <sdb-search-input
                    slot="right"
                    placeholder=${translate('search')}
                    value=${this.search}
                    @search=${(e) => { store.dispatch(loadCompositionsIfNeeded({
                        search: e.detail.searchText,
                        reload: true
                    })); }}>
                </sdb-search-input>
            </sdb-layout-60-40>
            <sdb-layout-100>
                ${!this.total
                    ? html`<sdb-status-message label=${translate('noCompositionsFound')}></sdb-status-message>`
                    : html`
                        <sdb-content-list separator>
                            <lit-virtualizer
                                id="compositions_list"
                                .items=${this.compositions}
                                .renderItem=${(composition, index) => this._renderCompositionListItem(composition, index)}
                                .scrollTarget=${document}>
                            </lit-virtualizer>
                        </sdb-content-list>
                    `
                }
            </sdb-layout-100>
        `;
    }

    firstUpdated() {
        this.dispatchEvent(
            new CustomEvent('fullscreen', {
                bubbles: true,
                composed: true,
                detail: {
                    fullscreen: false,
                },
            }),
        );
    }

    _renderCompositionListItem(composition, index) {
        store.dispatch(loadCompositionsIfNeeded({ index }));

        const menuItems = [
            {
                text: translate('accreditationinfo'),
                action: () => {
                    store.dispatch(navigate(`composition/${composition.uniqueId}/accreditationinfo`));
                },
            },
            {
                text: translate('accreditations'),
                action: () => store.dispatch(navigate(`composition/${composition.uniqueId}/accreditations`)),
            },
            {
                text: translate('preview'),
                action: () => previewComposition(composition.id),
            },
        ];

        return html`
            <sdb-content-listitem
                icon="fal fa-square-check"
                .headline=${composition.title}
                .subtitle="${translate('lastPublished')}: ${this._renderTimestamp(composition.lastModified)}"
                @click=${()=> { store.dispatch(navigate(`composition/${composition.uniqueId}`)); }}>

                <vaadin-context-menu
                    slot="secondaryAction"
                    open-on="click"
                    .items=${menuItems}
                    @item-selected=${(e) => {
                        e.stopPropagation();
                        e.detail.value?.action?.();
                    }}>
                    <sdb-content-iconbutton icon="fal fa-ellipsis-vertical"></sdb-content-iconbutton>
                </vaadin-context-menu>

            </sdb-content-listitem>
        `;
    }

    _renderTimestamp(field) {
        return moment((field || {}).timestamp).fromNow();
    }
}

